import Lottie from 'lottie-react';
import React from 'react';

import fireworksAnimation from '../../../../icons/lottie/fireworks.json';
import './GroupCard.scss';
import { LeaderboardGroup } from '../LeaderboardGroupLandingPage/useLeaderboardGroupLandingPage';

interface Props {
	group: LeaderboardGroup;
	rank: number;
	customStyles?: { [key: string]: string };
}

const GroupCard = ({
	group,
	rank,
	customStyles,
}: Props) => (
	<div className='marketing-leaderboard__leader-card-wrapper'>
		<div className='marketing-leaderboard__leader-card' style={customStyles}>
			<div className='leader-card__player-info'>
				<div className='leader-card__player-info__title'>
					<span>{rank}</span>
					<span>
						<b style={{fontSize: '0.6em'}}>{group.name}</b>
					</span>
				</div>
			</div>
			{group.clusterDistance && (
				<div
					className='leader-card__player-rank'
					style={{
						border: '0.0625em solid white',
						borderRadius: group.clusterDistance === 0 ? '50%' : '0',
						color: 'white',
					}}
				>
					<span>{`${group.clusterDistance.toFixed(1)}'`}</span>
					{group.clusterDistance === 0 && (
						<Lottie
							animationData={fireworksAnimation}
							loop
							autoplay
							style={{
								width: '7.375em',
								height: '7.375em',
								position: 'absolute',
								top: '-20%',
								left: '-20%',
							}}
						/>
					)}
				</div>
			)}
		</div>
		<div className='marketing-leaderboard__divider' />
	</div>
);

export default GroupCard;
